import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a6ff54c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "ms-auto"
}
const _hoisted_3 = {
  key: 1,
  class: "ms-auto"
}
const _hoisted_4 = { class: "uploader-view" }
const _hoisted_5 = {
  key: 0,
  class: "table-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Histórico", -1))
const _hoisted_7 = { class: "table-wrapper" }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = { class: "action-container" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "info-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Nueva importación de datos", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_18 = { class: "upload-container" }
const _hoisted_19 = { class: "container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Seleccione o arrastre un archivo para importar nuevos datos", -1))
const _hoisted_21 = { class: "el-upload__text" }
const _hoisted_22 = { class: "text-btn" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Archivos permitidos: *.csv")
], -1))
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  key: 0,
  class: "container"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/WEAS_LOGO.png",
    alt: "WeasLogo",
    class: "imagen-transparente"
  })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Este tipo de importación permite al usuario hacer una comparación entre los valores de las estimaciones de Aquacorp y los valores importados, las medidas de referencia de laboratorio. Solo se muestran las estimaciones correspondientes a los datos de referencia del laboratorio importados. ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Cómo debe ser el archivo importado?")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "El archivo debe generarse en formato *.csv con separador de columnas “;“."),
  /*#__PURE__*/_createElementVNode("li", null, " La primera columna corresponde a la fecha. La primera celda debe ser el texto “Fecha“ o “Fecha y hora“ y las celdas por debajo deben ser las fechas correspondientes a la medida tomada. Con el formato DD/MM/AAAA hh:mm:ss o DD/MM/AAAA hh:mm si no se cuenta con los segundos. "),
  /*#__PURE__*/_createElementVNode("li", null, " La segunda columna debe contener el código del parámetro fisicoquímico a importar, especificado en el menú desplegable 'Códigos de parámetros'. Las celdas por debajo deben incluir los valores correspondientes a las medidas tomadas, utilizando el formato de separador decimal con coma (','). "),
  /*#__PURE__*/_createElementVNode("div", { class: "container-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/TU.png",
      alt: "validacion",
      class: "imagen-center"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/tu_sinhoras.png",
      alt: "validacion",
      class: "imagen-center"
    })
  ])
], -1))
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { key: 2 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Este tipo de importación tiene como objetivo una comparación entre los valores de las estimaciones de Aquacorp y los valores importados, las medidas de referencia de laboratorio. Los datos se miden con una frecuencia diaria, pero se permite un ajuste de las horas para una mejor adaptación. ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Cómo debe ser el archivo importado?")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "El archivo debe generarse en formato *.csv con separador de columnas “;“."),
  /*#__PURE__*/_createElementVNode("li", null, " La primera columna del archivo corresponde a la fecha. La primera celda de esta columna debe ser el texto “Fecha“ y las celdas por debajo deben ser de las fechas correspondientes a las medidas tomadas. Con el formato DD/MM/AAAA. "),
  /*#__PURE__*/_createElementVNode("li", null, " La segunda columna debe contener el código del parámetro fisicoquímico a importar, especificado en el menú desplegable 'Códigos de parámetros'. Las celdas por debajo deben incluir los valores correspondientes a las medidas tomadas, utilizando el formato de separador decimal con coma (','). "),
  /*#__PURE__*/_createElementVNode("div", { class: "container-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/MuestrasInt.png",
      alt: "Muestras",
      class: "imagen-center"
    })
  ])
], -1))
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { key: 3 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Este tipo de importación permite al usuario hacer una comparación entre los valores de las estimaciones de Aquacorp y las medidas de referencia de laboratorio (los valores importados). Los datos se miden con la frecuencia asociada a los retornos. ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Cómo debe ser el archivo importado?")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "El archivo debe generarse en formato *.csv con separador de columnas “;“."),
  /*#__PURE__*/_createElementVNode("li", null, " La primera columna corresponde a la fecha. La primera celda debe ser el texto “Fecha“ o “Fecha y hora“ y las celdas por debajo deben ser de las fechas correspondientes a la medida tomada. Con el formato DD/MM/AAAA hh:mm:ss o DD/MM/AAAA hh:mm si no se cuenta con los segundos. "),
  /*#__PURE__*/_createElementVNode("li", null, " La segunda columna corresponde a los valores de los retornos. La primera celda debe ser \"RE\". El resto de celdas por debajo deben contener los valores de los retornos (únicamente habrán valores de “0“ o “1“). "),
  /*#__PURE__*/_createElementVNode("div", { class: "container-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/RE.png",
      alt: "Retornos",
      class: "imagen-center"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/RE_sinSegundos.png",
      alt: "Retornos",
      class: "imagen-center"
    })
  ])
], -1))
const _hoisted_42 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { key: 4 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Este tipo de importación permite al usuario hacer una comparación entre los valores de las estimaciones de Aquacorp y las medidas de referencia de laboratorio (los valores importados). Los datos se miden con la frecuencia asociada a los vertidos. ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Cómo debe ser el archivo importado?")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "El archivo debe generarse en formato *.csv con separador de columnas “;“."),
  /*#__PURE__*/_createElementVNode("li", null, " La primera columna corresponde a la fecha. La primera celda debe ser el texto “Fecha“ o “Fecha y hora“ y las celdas por debajo deben ser de las fechas correspondientes a la medida tomada. Con el formato DD/MM/AAAA hh:mm:ss o DD/MM/AAAA hh:mm si no se cuenta con los segundos. "),
  /*#__PURE__*/_createElementVNode("li", null, " La segunda columna corresponde a los valores de los retornos. La primera celda debe ser “VE“. El resto de celdas por debajo deben contener los valores de los vertidos (únicamente habrán valores de “0“ o “1“). "),
  /*#__PURE__*/_createElementVNode("div", { class: "container-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/VE.png",
      alt: "Vertidos",
      class: "imagen-center"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/VE_sinSegundos.png",
      alt: "Vertidos",
      class: "imagen-center"
    })
  ])
], -1))
const _hoisted_47 = [
  _hoisted_44,
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = { key: 5 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Cuando se importan datos de validación o muestras integradas es necesario especificar qué parámetro o parámetros se necesita importar. Para facilitar al usuario la importación, se adjunta la siguiente tabla en la que se vinculan los parámetros (columna “Nombre del parámetro“) con el código que se debe introducir en los documentos a importar (columna “Código del parámetro“): ", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = { class: "dialog-footer" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Cerrar")
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Nombre del archivo:", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = { class: "dialog-footer" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Cerrar")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Aceptar")

import { ref, onMounted, watch, Ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import SamplingPointCsvGraph from "@/components/samplingPoints/SamplingPointCsvGraph.component.vue";
import { UploadHistory } from "@/types/uploadHistory.type";
import {
  createUploadHistory,
  editUploadHistoryDescription,
  getUploadHistory,
  getSamplingPointById,
} from "@/service/samplingpoint.service";
import { getParameter } from "@/service/parameter.service";
import { Filter } from "@/types/filter.type";
import { Parameter } from "@/types/parameter.type";
import { SamplingPoint } from "@/types/samplingpoint.type";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const samplingPoint = ref<SamplingPoint | null>(null);
const uploadMessage = ref("Seleccionar archivo");
const csvContent = ref("");
const isCsv = ref(false);
const isLoading = ref(true);
const selectedValue = ref<string>("");
const fileName = ref("");
const previousUploads = ref<UploadHistory[]>([]);
const parameterName = ref("");
const parametersName = ref("");
const dateRange = ref("");
const infoModalVisible = ref(false);
let parameter = [] as Parameter[];
const modalDescVisible = ref(false);
const modalData = ref<UploadHistory>();
const selectedTimeFrom = ref<string>("");
const selectedTimeTo = ref<string>("");
const integradas = ref<string>("");
const startDate: Ref<string> = ref("");
const endDate: Ref<string> = ref("");
const selectedOption = ref("");
const currentPage = ref(1);
const pageSize = ref(10);

const handlePageChange = (page: number) => {
  currentPage.value = page;
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return date.toLocaleDateString("es-ES", options);
};
const formatDataInterval = (inputString: string) => {
  const datePattern = /\d{2}\/\d{2}\/\d{4}/g;
  const dates = inputString.match(datePattern);

  if (!dates) {
    return [];
  } else if (!dates[1]) {
    return `${dates[0]}`;
  }

  return `${dates[0]} - ${dates[1]}`;
};

const formattedUploads = ref<UploadHistory[]>([]);

// const parameters = [
//   { nombre: "Turbidez", codigo: "TU" },
//   { nombre: "Sólidos en Suspensión", codigo: "SS" },
//   { nombre: "Sólidos disueltos", codigo: "SD" },
//   { nombre: "MES", codigo: "MES" },
//   { nombre: "Conductividad", codigo: "CE" },
//   { nombre: "REDOX", codigo: "RE" },
//   { nombre: "DQO", codigo: "DQ" },
//   { nombre: "DBO", codigo: "DB" },
//   { nombre: "Carbono Orgánico Disuelto", codigo: "CO" },
//   { nombre: "Carbono Orgánico Total", codigo: "CT" },
//   { nombre: "Nitrógeno Total", codigo: "NT" },
//   { nombre: "Nitrato", codigo: "NO" },
//   { nombre: "Oxígeno Disuelto", codigo: "OD" },
//   { nombre: "pH", codigo: "PH" },
//   { nombre: "Fósforo", codigo: "FO" },
//   { nombre: "Fosfato", codigo: "FT" },
//   { nombre: "Ortofosfato", codigo: "OR" },
//   { nombre: "Amonio", codigo: "NH" },
//   { nombre: "Hierro", codigo: "FE" },
//   { nombre: "Manganeso", codigo: "MN" },
//   { nombre: "Aceites y grasas", codigo: "AYG" },
//   { nombre: "Espumas", codigo: "ES" },
//   { nombre: "Lentejas", codigo: "LE" },
//   { nombre: "Retorno", codigo: "RE" },
//   { nombre: "Color", codigo: "CR" },
//   { nombre: "Algas verdeazuladas", codigo: "AVA" },
//   { nombre: "Algas verdes", codigo: "AVE" },
//   { nombre: "Clorofila A (algas verdeazuladas)", codigo: "CL_AVA" },
//   { nombre: "Clorofila A (algas verdes)", codigo: "CL_AVE" },
//   { nombre: "Clorofila A (diatomeas)", codigo: "CL_DI" },
//   { nombre: "Clorofila A (cryptophytas)", codigo: "CL_CR" },
//   { nombre: "Clorofila A total", codigo: "CL_T" },
//   { nombre: "Cryptophytas (control de algas superficie)", codigo: "CAS_CR" },
//   { nombre: "Diamoteas (control de algas superficie)", codigo: "CAS_DI" },
//   { nombre: "Total algas (control de algas superficie)", codigo: "CAS_T" },
// ];

const parameters = computed(() => {
  if (samplingPoint.value?.parameters) {
    return samplingPoint.value.parameters.map((param) => ({
      nombre: param.name,
      codigo: param.code,
    }));
  } else {
    return [];
  }
});

const paginatedParameters = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return parameters.value.slice(start, end);
});

watch(previousUploads, (newUploads) => {
  formattedUploads.value = newUploads
    .map((upload) => ({
      ...upload,
      formattedDateTime: formatDate(upload.dateTime),
      formattedDataInterval: formatDataInterval(upload.dataInterval),
      parameter: upload.parameter == "Matriz de Agua\r" ? "Retorno" : upload.parameter,
    }))
    .reverse();
});

onMounted(async () => {
  samplingPoint.value = await getSamplingPointById(parseInt(route.params.samplingPoint as string));

  previousUploads.value = await getUploadHistory(Number(route.params.samplingPoint));

  integradas.value = route.query.integradas as string;
  if (integradas.value) {
    selectedValue.value = "Muestras integradas";
  }
  startDate.value = sessionStorage.getItem("startDate") || "";
  endDate.value = sessionStorage.getItem("endDate") || "";

  isLoading.value = false;
});

const handleFileChange = (file: { name: string; raw: Blob }) => {
  fileName.value = file.name;
  const reader = new FileReader();
  reader.onload = (e: any) => {
    csvContent.value = e.target.result;
    processCsvData(csvContent.value);
  };
  reader.readAsText(file.raw);
};

const beforeUpload = async (file: { type: string }) => {
  if (!selectedValue.value) {
    isCsv.value = false;
    ElMessage.warning("Debe seleccionar un tipo de importación antes de subir un archivo");
    return false;
  }
  if (file.type !== "text/csv") {
    isCsv.value = false;
    ElMessage.warning("Solo se aceptan archivos .csv");
    return false;
  }
  isCsv.value = true;
  ElMessage.success("Archivo CSV recibido");
  return true;
};

const handleExceed = () => {
  ElMessage.warning("Debe importarse únicamente un archivo");
  isCsv.value = false;
  isLoading.value = false;
  csvContent.value = "";
  fileName.value = "";
};

const goBack = async () => {
  if (isCsv.value) {
    selectedValue.value = "";
    isCsv.value = false;
    isLoading.value = false;
    csvContent.value = "";
    fileName.value = "";
    selectedTimeFrom.value = "";
    selectedTimeTo.value = "";
    if (integradas.value) {
      selectedValue.value = "Muestras integradas";
    }
  } else {
    if (integradas.value) {
      let samplingPoint = await getSamplingPointById(
        parseInt(route.params.samplingPoint as string)
      );
      router.push(
        "/support/samplingPoints/" +
          samplingPoint.container?.id +
          "?samplingPoint=" +
          route.params.samplingPoint
      );
    } else {
      router.push("/support/import");
    }
  }
};

const openModalDesc = (row: UploadHistory) => {
  modalData.value = { ...row };
  modalDescVisible.value = true;
};

const closeModalDesc = () => {
  modalDescVisible.value = false;
};

const saveDescription = async () => {
  if (
    modalData.value &&
    typeof modalData.value.id === "number" &&
    typeof modalData.value.description === "string"
  ) {
    try {
      await editUploadHistoryDescription({
        id: modalData.value.id,
        description: modalData.value.description,
      });
      ElMessage.success("Descripción actualizada");
      modalDescVisible.value = false;
      previousUploads.value = await getUploadHistory(Number(route.params.samplingPoint));
    } catch (error) {
      ElMessage.error("Error al actualizar la descripción");
    }
  }
};
const processCsvData = async (csvContent: string) => {
  const rows = csvContent.split("\n").map((row: string) => row.split(";"));
  parameterName.value = rows[0][1].replace("\r", "");

  const parameterCodes = rows[0].slice(1).map((param) => param.replace("\r", ""));

  const orderedParameterCodes = [...parameterCodes];

  const filter: Filter = {
    fields: {
      "parameter.code": {
        operator: "in",
        value: parameterCodes,
      },
    },
  };

  const parameterData = await getParameter(undefined, undefined, filter);

  if (parameterData?.data) {
    parameter = orderedParameterCodes
      .map((code) => parameterData.data.find((p) => p.code === code))
      .filter(Boolean) as Parameter[];

    const parameterNames = parameter.map((p) => p.name);
    parametersName.value = parameterNames.join(", ");
  }

  const dates = rows.slice(1).map((row: any[]) => row[0]);

  if (dates[0] === dates[dates.length - 1]) {
    dateRange.value = `${dates[0]}`;
  } else {
    dateRange.value = `${dates[0]} - ${dates[dates.length - 1]}`;
  }
};

watch(csvContent, async (newValue, oldValue) => {
  csvContent.value = newValue;
  if (newValue && newValue !== oldValue && isCsv.value && selectedValue.value) {
    const filter: Filter = {
      fields: {
        "parameter.code": {
          operator: "equal",
          value: parameterName.value,
        },
      },
    };
    const parameterData = (await getParameter(undefined, undefined, filter))?.data;
    if (parameterData?.length) {
      if (selectedValue.value === "Retornos") {
        if (
          parametersName.value.trim().replace("\r", "") !== "Retorno" ||
          parametersName.value.length !== 7
        ) {
          ElMessage.warning("El parámetro importado debe ser Retorno");
          isLoading.value = false;
          isCsv.value = false;
          csvContent.value = "";
          selectedValue.value = "";
          return;
        }
      }
      try {
        await createUploadHistory({
          dateTime: new Date(),
          type: selectedValue.value,
          parameter: parametersName.value,
          archive: fileName.value,
          dataInterval: dateRange.value,
          description: "",
          samplingPointId: Number(route.params.samplingPoint),
        });
        ElMessage.success("Datos del CSV guardados");
        isLoading.value = true;
        isCsv.value = true;
      } catch (error) {
        ElMessage.error("Error al guardar los datos del CSV");
      }
    } else {
      isCsv.value = false;
      csvContent.value = "";
      ElMessage.warning("El parámetro del documento no es válido");
    }
  }
});

const openInfoDialog = () => {
  infoModalVisible.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { class: "header" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_page_header, {
          title: _ctx.$t('placeholder.goBack'),
          onBack: goBack,
          class: "header"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (!isCsv.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Importación de datos"))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(selectedValue.value), 1))
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { class: "card-history" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (!isCsv.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_table, {
                    data: formattedUploads.value,
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "type",
                        label: "Tipo de importación",
                        "header-cell-style": { backgroundColor: '#f2f2f2' }
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "parameter",
                        label: "Parámetro/s",
                        align: "center",
                        "header-align": "center",
                        "header-cell-style": { backgroundColor: '#f2f2f2' }
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", {
                            class: "description-cell1",
                            title: row.parameter
                          }, _toDisplayString(row.parameter || "-"), 9, _hoisted_8)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "archive",
                        label: "Nombre del archivo",
                        align: "center",
                        "header-align": "center"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", {
                            class: "description-cell",
                            title: row.archive
                          }, _toDisplayString(row.archive), 9, _hoisted_9)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "dataInterval",
                        label: "Periodo de los datos importados",
                        align: "center",
                        "header-align": "center"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", {
                            title: row.dataInterval
                          }, _toDisplayString(row.formattedDataInterval), 9, _hoisted_10)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "formattedDateTime",
                        label: "Fecha de importación",
                        align: "center",
                        "header-align": "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "description",
                        label: "Descripción",
                        align: "center",
                        "header-align": "center",
                        flex: 1
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", {
                            class: "description-cell",
                            title: row.description,
                            onClick: ($event: any) => (openModalDesc(row))
                          }, _toDisplayString(row.description || "-"), 9, _hoisted_11)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Acciones",
                        align: "right",
                        "header-align": "right"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("i", {
                              class: "el-icon el-icon-edit fas btn",
                              onClick: ($event: any) => (openModalDesc(row)),
                              title: "Hacer click para agregar o modificar una descripción"
                            }, null, 8, _hoisted_13)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!isCsv.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_button, {
                    class: "info",
                    size: "small",
                    onClick: openInfoDialog,
                    circle: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_el_select, {
                      modelValue: selectedValue.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
                      placeholder: "Tipo de importación",
                      class: "upload-select"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "Validación",
                          class: "option"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.upload.validation")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          value: "Muestras integradas",
                          class: "option"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.upload.integratedSamples")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          value: "Retornos",
                          class: "option"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.upload.returns")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          value: "Vertidos",
                          class: "option"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.upload.waste")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (selectedValue.value === 'Muestras integradas')
                      ? (_openBlock(), _createBlock(_component_el_time_picker, {
                          key: 0,
                          modelValue: selectedTimeFrom.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTimeFrom).value = $event)),
                          format: "HH:mm",
                          placeholder: "Inicio del periodo",
                          class: "time-picker",
                          align: "right"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (selectedValue.value === 'Muestras integradas')
                      ? (_openBlock(), _createBlock(_component_el_time_picker, {
                          key: 1,
                          modelValue: selectedTimeTo.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTimeTo).value = $event)),
                          format: "HH:mm",
                          placeholder: "Fin del periodo",
                          class: "time-picker",
                          align: "right"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_upload, {
                    class: "upload",
                    drag: "",
                    action: "",
                    accept: ".csv",
                    limit: 1,
                    "show-file-list": false,
                    "on-change": handleFileChange,
                    "before-upload": beforeUpload,
                    "on-exceed": handleExceed
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(uploadMessage.value), 1)
                      ]),
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (csvContent.value)
                  ? (_openBlock(), _createBlock(SamplingPointCsvGraph, {
                      key: 0,
                      csvContent: csvContent.value,
                      selectedValue: selectedValue.value,
                      parameter: _unref(parameter)[0],
                      selectedTimeFrom: selectedTimeFrom.value,
                      selectedTimeTo: selectedTimeTo.value
                    }, null, 8, ["csvContent", "selectedValue", "parameter", "selectedTimeFrom", "selectedTimeTo"]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _createVNode(_component_el_dialog, {
          modelValue: infoModalVisible.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((infoModalVisible).value = $event)),
          title: "Información sobre la importación",
          "custom-class": 'info-modal',
          "show-close": false
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_51, [
              _createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (infoModalVisible.value = false)),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_52
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_select, {
                modelValue: selectedOption.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedOption).value = $event)),
                placeholder: "Seleccione una opción",
                style: {"margin-bottom":"30px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    class: "option",
                    label: _ctx.$t('label.upload.validation'),
                    value: "validacion"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    class: "option",
                    label: _ctx.$t('label.upload.integratedSamples'),
                    value: "muestras"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    class: "option",
                    label: _ctx.$t('label.upload.returns'),
                    value: "retornos"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    class: "option",
                    label: _ctx.$t('label.upload.waste'),
                    value: "vertidos"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    class: "option",
                    label: _ctx.$t('label.upload.parameterCodes'),
                    value: "param"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (selectedOption.value === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                : _createCommentVNode("", true),
              (selectedOption.value === 'validacion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_32))
                : _createCommentVNode("", true),
              (selectedOption.value === 'muestras')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_37))
                : _createCommentVNode("", true),
              (selectedOption.value === 'retornos')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_42))
                : _createCommentVNode("", true),
              (selectedOption.value === 'vertidos')
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_47))
                : _createCommentVNode("", true),
              (selectedOption.value === 'param')
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _hoisted_49,
                    _createVNode(_component_el_table, {
                      data: _unref(paginatedParameters),
                      class: "parameter-table"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "nombre",
                          label: "Nombre del parámetro"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "codigo",
                          label: "Código del parámetro"
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    _createVNode(_component_el_pagination, {
                      onCurrentChange: handlePageChange,
                      "current-page": currentPage.value,
                      "page-size": pageSize.value,
                      total: _unref(parameters).length,
                      layout: "prev, pager, next",
                      style: {"text-align":"center","margin-top":"20px"}
                    }, null, 8, ["current-page", "page-size", "total"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_50
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: modalDescVisible.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((modalDescVisible).value = $event)),
          title: "Editar descripción",
          width: "50%"
        }, {
          default: _withCtx(() => [
            (modalData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("p", null, [
                    _hoisted_54,
                    _createTextVNode(" " + _toDisplayString(modalData.value.archive), 1)
                  ]),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modalData.value.description) = $event)),
                    maxlength: 150,
                    class: "textarea"
                  }, null, 512), [
                    [_vModelText, modalData.value.description]
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_55,
            _createElementVNode("span", _hoisted_56, [
              _createVNode(_component_el_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (modalDescVisible.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_57
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: saveDescription
              }, {
                default: _withCtx(() => [
                  _hoisted_58
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})